import React from 'react';
import PropTypes from 'prop-types';

export const ProgramContentCard = ({ children }) => <div className="index-screen__programcontentcard">{children}</div>;

ProgramContentCard.propTypes = {
  children: PropTypes.node.isRequired,
};
